import { useEffect, useState } from "react"
import { ModelListDashboardItem, PoProject } from "../api/__gen__/data-contracts"
import { getPublicApiProjects, getPublicTableProjects } from "./workspace/apis"
import { fetchCommunityDashboards } from "../modules/dashboard/DashboardListState"

export const useExploreData = () => {
  const [publicTables, setPublicTables] = useState<PoProject[]>([])
  const [publicApis, setPublicApis] = useState<PoProject[]>([])
  const [publicDashboards, setPublicDashboards] = useState<ModelListDashboardItem[]>([])

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const fetchAndSetPublicProjects = async () => {
    setIsLoading(true)
    const apiProjects = await getPublicApiProjects()
    const tableProjects = await getPublicTableProjects()
    const dashboards = await fetchCommunityDashboards()
    setIsLoading(false)

    setPublicApis(apiProjects)
    setPublicTables(tableProjects)
    setPublicDashboards(dashboards?.data?.items || [])
  }

  useEffect(() => {
    fetchAndSetPublicProjects()
  }, [])

  return {
    publicApis,
    publicTables,
    publicDashboards,
    refecth: fetchAndSetPublicProjects,
    isLoading
  }
}

